import React from 'react';

export type MainProps = {
  children: React.ReactNode;
  className?: string;
};
export default function Main({ children, className = '' }: MainProps) {
  return (
    <div
      className={`h-full w-full p-[15px] overflow-auto md:pb-1.5 md:min-w-[600px] ${className}`}
    >
      {children}
    </div>
  );
}
